import { render, staticRenderFns } from "./SelectGoodsCard.vue?vue&type=template&id=66fb9eae&scoped=true"
import script from "./SelectGoodsCard.vue?vue&type=script&lang=ts"
export * from "./SelectGoodsCard.vue?vue&type=script&lang=ts"
import style0 from "./SelectGoodsCard.vue?vue&type=style&index=0&id=66fb9eae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb9eae",
  null
  
)

export default component.exports